const mutations = {
  setStatus(state, data) {
    state.newsEdit = data
  },
  setDeleteStatus(state, data) {
    state.newsDelete = data
  }
}

export default mutations